<section>
  <section class="heading" data-testid="active-state-title">
    <app-dot-pulse />
    <p class="body bold">Repairer to arrange</p>
  </section>

  @if (vm.isTvRemoteReplacement) {
    <p class="body mt-8">
      The repairer will be in touch directly. Your booking details should show 24 hours after they’ve contacted you.
    </p>
  } @else {
    <p class="body mt-8">
      The repairer has their own booking system. So, they’ll be in touch directly to arrange your engineer visit.
    </p>
  }
</section>
